import { currentOrigin } from 'src/app-config';
import { daysOfTheWeekP, generalHelpers } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { HTHActivityServiceCrud } from './HTHActivity2ServiceCrud';
import { HTHActivityTerritory } from './HTHActivity3Territory';
import { typeHTHTerritory, typePublicMinistryMonthlyService, typePublicMinistryService } from '@monorepo/models';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import CopyToClipboard from 'react-copy-to-clipboard';

type propsType = {
    completionDate: number;
    day?: number;
    hthTerritories: typeHTHTerritory[];
    monthlyService: typePublicMinistryMonthlyService;
    service: typePublicMinistryService;
    services: typePublicMinistryService[];
    setHthTerritories: Dispatch<SetStateAction<typeHTHTerritory[] | null>>;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const HTHActivityService: FC<propsType> = ({
    completionDate, day, hthTerritories, monthlyService, service, services, setHthTerritories, setRefreshCounter
}) => {
    const [copiedLinkToClipboard, setCopiedLinkToClipboard] = useState(false);
    const [isShowing, setIsShowing] = useState(false);
    const [isShowingCrud, setIsShowingCrud] = useState(false);
    const config = useGetConfig();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    useEffect(() => {
        if (!copiedLinkToClipboard) {
            return;
        }
        setTimeout(() => {
            setCopiedLinkToClipboard(false);
        }, 5000);
    }, [copiedLinkToClipboard]);

    return (
        <div key={service.id}
            className={`card ${isDarkMode ? 'text-white border' : ''} ${!!day ? 'mt-3 mb-2 mx-3' : 'mt-1 mb-2'}`}
        >
            {isShowingCrud &&
                <HTHActivityServiceCrud
                    closeModal={() => setIsShowingCrud(false)}
                    monthlyService={monthlyService}
                    service={service}
                    setRefreshCounter={setRefreshCounter}
                />
            }
            <div className={`card-header d-flex flex-column justify-content-center flex-xl-row justify-content-xl-between ${isDarkMode ? 'bg-dark' : 'bg-general-blue text-white'} ${isShowing ? 'border-bottom' : 'rounded'} p-2`}>
                <h6 className={'pointer mb-1'}
                    style={{ paddingTop: '6px' }}
                    onClick={() => setIsShowing(x => !x)}
                >
                    {!day && `${service.typeOfRegularity <= 2 ? `Los ${daysOfTheWeekP[service.weekday!]}` : `El ${daysOfTheWeekP[service.weekday!]} ${service.day}`} a las`} {service.hour.toString().padStart(2, '0')}:{service.minutes.toString().padStart(2, '0')} hs. - {service.captain1 ? `${service.captain1?.name} ${service.captain1?.lastName}` : 'Sin capitán'} {service.territories.length && `(T. ${service.territories.join(', ')}, completado: ${Math.round(service.territories.reduce((ac, t) => ac + hthTerritories.find(_t => _t.number === t)!.faces.filter(p => p.serviceDates.find(sd => sd.serviceId === service.id)).length, 0) * 100 / service.territories.reduce((ac, t) => ac + hthTerritories.find(_t => _t.number === t)!.faces.length, 0))}%)`}
                </h6>
                <div>
                    <button className={`btn btn-sm btn-general-blue border ${isMobile ? 'w-100 my-2' : 'me-1'}`}
                        onClick={() => setIsShowingCrud(true)}
                    >
                        Agregar un Territorio
                    </button>
                    {services.some(s => s.territories.length) &&
                        <CopyToClipboard
                            text={generalHelpers.GetLinkTextForHthActivityFeedback(currentOrigin, config.congregation, service.id, completionDate, config.isUsingLettersForBlocks)}
                        >
                            <button className={`btn btn-sm ${copiedLinkToClipboard ? 'btn-general-red' : 'btn-general-blue'} border ${isMobile ? 'w-100' : 'ms-1'}`}
                                onClick={() => setCopiedLinkToClipboard(true)}
                            >
                                {copiedLinkToClipboard ? 
                                    "Copiado! Otro click para volver a copiar"
                                    :
                                    "Generar link para compartir"
                                }
                            </button>
                        </CopyToClipboard>
                    }
                </div>
            </div>
            {isShowing &&
                <div className={`card-body ${isDarkMode ? 'bg-dark' : 'bg-lightgrey border border-secondary'}`}>
                    {service.territories.map(t =>
                        <HTHActivityTerritory key={t}
                            completionDate={completionDate}
                            day={day}
                            hthTerritory={hthTerritories.find(_t => _t.number === t)!}
                            monthlyService={monthlyService}
                            service={service}
                            setHthTerritories={setHthTerritories}
                        />
                    )}
                </div>
            }
        </div>
    );
}
